import { useFormContext } from 'react-hook-form';

import { useAssigneeOptionsList } from 'hooks/useAssigneeOptionsList';

import { QueryResponse as Risk } from 'api/queries/getRisk.query';

import { CommentsDesktop } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/comments/comments.desktop';
import { userMentionMapper } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/MainCard.utils';

export const Comments = () => {
    const options = useAssigneeOptionsList();
    const { watch } = useFormContext<Risk>();

    const mappedOptions = options.map((item) => userMentionMapper(item.assignee));

    return (
        <CommentsDesktop
            id={watch('cardId')}
            isVirtual={false}
            assigneeOptions={mappedOptions}
            enableQuickComments={false}
        />
    );
};
